import { render } from "./StereotypeApplicator.vue?vue&type=template&id=31220947"
import script from "./StereotypeApplicator.vue?vue&type=script&lang=js"
export * from "./StereotypeApplicator.vue?vue&type=script&lang=js"

import "./StereotypeApplicator.vue?vue&type=style&index=0&id=31220947&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__